import { z } from 'zod';
// Canonical source of the UI language set — the single guest list every wire
// contract validates against (CONVENTIONS §i18n; the ADR-009 single-source rule
// applied to the language enum that had drifted into per-schema copies).
//
// STORED LANGUAGE IS LANGUAGE-ONLY (`en` | `fr` | `ar`) — never a region-tagged
// BCP-47 tag like `ar-SA`. The DB columns are `varchar(2)` to match. Region is a
// *formatting* concern (Arabic-Indic digits + Arabic month names), derived from
// the language at date/number-formatting time — it is NOT stored here, and the
// Gregorian calendar is always used (no Hijri/Islamic calendar).
//
// The DATABASE mirrors this set in two CHECK constraints — keep them in sync
// when adding a language:
//   backend/migrations/000_baseline_schema.sql
//     · chk_users_language            (the user's real language — column `language`)
//     · chk_projects_default_language (per-project default helper)
// (SQL can't import this module; the migration comments point back here.)
// The frontend i18n `supportedLngs` imports `LANGUAGES` directly, so the app and
// the API share this one line.
export const LANGUAGES = ['en', 'fr', 'ar'];
export const LanguageSchema = z.enum(LANGUAGES);
